import React, { useState, FC } from 'react';
import * as emailjs from 'emailjs-com';
import * as yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PersonType } from '../types';
import { stringifyPersons, ageToGroup } from '../utils';
import covers from '../data/covers';

const validationSchema = yup.object({
  name: yup.string().required('יש להזין שם מלא'),
  phone: yup
    .string()
    .required('יש להזין טלפון')
    .min(5, 'הטלפון שהוזן אינו תקין'),
  email: yup
    .string()
    //.required('יש להזין כתובת מייל')
    .email('המייל שהוזן אינו תקין'),
});

type FormDataType = {
  name: string;
  phone: string;
  email: string;
  message: string;
};

const initialFormData: FormDataType = {
  name: '',
  phone: '',
  email: '',
  message: '',
};

type ContactFormProps = {
  persons: PersonType[];
};

const ContactForm: FC<ContactFormProps> = ({ persons }) => {
  const [formData, setFormData] = useState(initialFormData);
  const [mailSent, setMailSent] = useState(false);
  const [error, setError] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  //console.log(stringifyPersons(persons));

  const handleSubmit = async (formData: FormDataType) => {
    setError(false);
    setIsDisabled(true);
    const templateParams = {
      tpl_name: formData.name,
      tpl_phone: formData.phone,
      tpl_email: formData.email,
      tpl_message: formData.message,
      tpl_persons: stringifyPersons(persons),
      tpl_total: (
        persons.reduce((totalSum, person) => {
          totalSum += person.covers.reduce(
            (sum, cover, index) =>
              (sum += cover ? covers[index].prices[ageToGroup(person.age)] : 0),
            0
          );
          return totalSum;
        }, 0) * 0.8
      ).toFixed(2),
    };

    try {
      await emailjs.send(
        'gmail', //serviceID
        'lead', //templateID
        templateParams, //templateParams
        'user_JJ0vflAqJgNqR2QCZfTgU' // UserIDf61eb92529cc414a5e35a00a6b7b141b
      );
      console.log('success');
      setMailSent(true);
    } catch (e) {
      console.log('error', e);
      setError(true);
      setIsDisabled(false);
    } finally {
      console.log('finally');
      setIsDisabled(false);
      resetForm();
    }
  };

  const resetForm = () => {
    setFormData(initialFormData);
  };

  return (
    <div className="form">
      {mailSent ? (
        <div className="success">
          <span>הנתונים נשלחו בהצלחה!</span>
          נציגינו יצרו עימך קשר בהקדם
        </div>
      ) : (
          <Formik
            initialValues={initialFormData}
            onSubmit={(values: FormDataType) => {
              setFormData(values);
              handleSubmit(values);
            }}
            validationSchema={validationSchema}
          >
            {({ errors, touched, handleChange }) => (
              <Form>
                <span className="form_title">מלאו את הפרטים כדי להתקדם</span>
                <div className="formCon">
                  <div className="field">
                    <label>שם מלא: *</label>
                    <Field name="name" />
                    {errors.name && touched.name ? (
                      <div className="fieldError">{errors.name}</div>
                    ) : null}
                  </div>
                  <div className="field">
                    <label>טלפון: *</label>
                    <Field name="phone" />
                    {errors.phone && touched.phone ? (
                      <div className="fieldError">{errors.phone}</div>
                    ) : null}
                  </div>
                  <div className="field">
                    <label>אימייל:</label>
                    <Field name="email" />
                    {errors.email && touched.email ? (
                      <div className="fieldError">{errors.email}</div>
                    ) : null}
                  </div>
                  <div className="field">
                    <label>הערות:</label>
                    <Field name="message" />
                  </div>
                  <div className="form_button">
                    {/*<input type="submit" value="שלח עכשיו" className="submit"/>*/}
                    {isDisabled ? (
                      <button className="disabled" disabled={isDisabled}>
                        <span>שולח נתונים...</span>
                      </button>
                    ) : (
                        <button
                          type="submit"
                      /*onClick={() => handleSubmit(formData, yupSchema)}*/ disabled={
                            isDisabled
                          }
                        >
                          <span>שלח עכשיו</span>
                          <FontAwesomeIcon icon={faPaperPlane} />
                        </button>
                      )}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )}

      {error ? (
        <div className="error">
          <p>
            מצטערים ישנה שגיאה,
            <br />
            יש לנסות לשלוח שוב או במועד מאוחר יותר
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default ContactForm;
